import { ProductTileModel } from "@api/mappers/products.mapper";
import { DeliveryTypes, ProductVisibilityTypes } from "./enums";
import { getDeliveryType } from "@redux/modules/value/productDetail/productDetail.module";

export const getPossibleDeliveryOptions = (visibilityType: ProductVisibilityTypes, deliveryTypes: DeliveryTypes[]) => {
    let activeVisibilityType = visibilityType;

    //Can be deleted once hybris doesn't send EXPRESS codes
    if (
        visibilityType === ProductVisibilityTypes.CollectAndExpressDelivery
    ) {
        activeVisibilityType = ProductVisibilityTypes.Collect;
    }

    if (
        visibilityType ===
        ProductVisibilityTypes.DeliveryAndExpressDeliveryAndCollect
    ) {
        activeVisibilityType = ProductVisibilityTypes.DeliveryAndCollect;
    }

    return deliveryTypes.filter(option => {
        if (
            option === DeliveryTypes.HomeDelivery &&
            activeVisibilityType === ProductVisibilityTypes.Collect
        )
            return false;

        if (
            option === DeliveryTypes.ClickAndCollect &&
            activeVisibilityType === ProductVisibilityTypes.Delivery
        )
            return false;

        return true;
    });
};

export const getDefaultAddToCartValues = (product: ProductTileModel, preferredStore?: string) => {
    const deliveryOptions = getPossibleDeliveryOptions(product.productVisibilityType, product.deliveryTypes || []);
    let defaultDeliveryMethod = getDeliveryType();

    if (!deliveryOptions.includes(defaultDeliveryMethod)) {
        defaultDeliveryMethod = deliveryOptions[0]
    }

    // If the default delivery method is PICKUP_IN_STORE, and HOME_DELIVERY is available,
    // and no preferred store is available, set the defaultDeliveryMethod to HOME_DELIVERY.
    if (defaultDeliveryMethod === DeliveryTypes.ClickAndCollect && deliveryOptions.includes(DeliveryTypes.HomeDelivery) && !preferredStore) {
        defaultDeliveryMethod = DeliveryTypes.HomeDelivery;
    }

    // If the default delivery method is PICKUP_IN_STORE, and HOME_DELIVERY is _NOT_ available,
    // and no preferred store is available, instant add to cart is not possible.
    if (defaultDeliveryMethod === DeliveryTypes.ClickAndCollect && !deliveryOptions.includes(DeliveryTypes.HomeDelivery) && !preferredStore) {
        return { defaultDeliveryMethod: null, defaultQuantity: null };
    }

    const defaultQuantity = defaultDeliveryMethod === DeliveryTypes.ClickAndCollect ? 1 : product.minimumOrderQuantity;
    return { defaultDeliveryMethod, defaultQuantity };
}

const VisibilityTypeToDeliveryTypesMap: Record<ProductVisibilityTypes, DeliveryTypes[]> = {
    [ProductVisibilityTypes.DeliveryAndExpressDeliveryAndCollect]: [
        DeliveryTypes.ClickAndCollect,
        DeliveryTypes.HomeDelivery
    ],
    [ProductVisibilityTypes.DeliveryAndCollect]: [
        DeliveryTypes.ClickAndCollect,
        DeliveryTypes.HomeDelivery
    ],
    [ProductVisibilityTypes.CollectAndExpressDelivery]: [
        DeliveryTypes.ClickAndCollect
    ],
    [ProductVisibilityTypes.Collect]: [
        DeliveryTypes.ClickAndCollect
    ],
    [ProductVisibilityTypes.Delivery]: [
        DeliveryTypes.HomeDelivery
    ],
    [ProductVisibilityTypes.OnlyAvailableInStore]: [],
    [ProductVisibilityTypes.NotAvailable]: [],
    [ProductVisibilityTypes.TemporaryNotAvailable]: [],
    [ProductVisibilityTypes.Free]: [],
    [ProductVisibilityTypes.Offline]: [],
    [ProductVisibilityTypes.Default]: [],
}
export const getAllowedDeliveryTypes = (productVisibilityType: ProductVisibilityTypes) => VisibilityTypeToDeliveryTypesMap[productVisibilityType]
